import React, {useCallback} from "react";
import { useStylesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const StyleSelect = (props) => {
    const query = useStylesQueryQuery();
    const filterOptions = useCallback((options)=> {
        return options.filter((element)=>{
            // eslint-disable-next-line react/prop-types, react/display-name
            if(props.isPackStyle && element.is_pack_style) return true;
            // eslint-disable-next-line react/prop-types, react/display-name
            if(props.isSiteStyle && element.is_site_style) return true;
            // eslint-disable-next-line react/prop-types, react/display-name
            if(!props.id) return true;
            return false;
        });
        // eslint-disable-next-line react/prop-types, react/display-name
    },[props.isPackStyle,props.isSiteStyle]);

    return <GraphQlSelect queryResult={query} {...props}  filterOptions={filterOptions} labelField="label" />;
}
